import { Link } from 'react-router-dom';
import IVCalculator from '../components/IVCalculator';
import SEOHead from '../components/SEOHead';
import AdSpace from '../components/AdSpace';

export default function IVCalculatorPage() {
  return (
    <>
      <SEOHead
        title="IV Calculator — Implied Volatility Rank & Percentile for Indian F&O | OptionView"
        description="Free Implied Volatility calculator for 53 Indian F&O symbols. Check IV Rank (52-week) and IV Percentile (90-day) for NIFTY, Bank Nifty, Fin Nifty and all NIFTY 50 stocks. Updated daily from NSE Bhavcopy at 6:30 PM IST."
        canonicalPath="/iv-calculator"
        keywords="IV calculator India, implied volatility rank, IV percentile, NIFTY IV, Bank Nifty IV, Fin Nifty IV, NSE F&O, options volatility India, IV rank calculator"
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-4">
        <Link to="/" className="inline-flex items-center gap-1 text-xs text-neutral-400 dark:text-neutral-500 hover:text-primary-600 dark:hover:text-primary-400 transition-colors mb-2">
          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
          Back to Home
        </Link>
      </div>
      <IVCalculator />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4">
        <AdSpace size="banner" />
      </div>
    </>
  );
}
